<div class="calculations__trigger"(click)="calculationsTrigger()" [ngClass]="active ? 'active' : ''"></div>
<div class="calculations">
    <div class="calculations__container" [ngClass]="active ? 'active' : ''">
        <div class="row">
            <div class="row__item">
                <div class="areaCoverage" (click)="areaCoverageTrigger()"></div>
            </div>
            <div class="row__item">
                <div class="areaPerformance" (click)="areaPerformanceTrigger()"> </div>
            </div>
             <div class="row__item">
                <div class="procedureAnalysis" (click)="procedureAnalysisTrigger()"> </div>
            </div>
        </div>
    </div>
</div>
